import type { ComponentProps } from 'react';

import { Button } from '~/domains/design-system/Button';
import testing from '~/testing';

type GamecenterPlayerDetailActionProps = {
  onClick: () => void;
  label: string;
  isHidden?: boolean;
  variant?: ComponentProps<typeof Button>['variant'],
};

function GamecenterPlayerDetailAction({
  onClick,
  isHidden,
  label,
  variant = 'primary-fill'
}: GamecenterPlayerDetailActionProps) {
  if (isHidden) return null;

  return (
    <Button
      data-test-id={testing.contest.game.common.dfs.playerDetail.action}
      style={{ width: '100%' }}
      onClick={onClick}
      variant={variant}
      size="medium"
    >
      {label}
    </Button>
  );
}

export default GamecenterPlayerDetailAction;

export type { GamecenterPlayerDetailActionProps };
